<template>
    <div>
      <el-button type="primary" @click="getDirectorList">查询</el-button>
      <el-button type="primary" @click="getDirectorById">单个查询</el-button>
      <el-button type="primary" @click="addDirector">增加</el-button>
      <el-button type="primary" @click="deleteDirector">删除</el-button>
      <el-button type="primary" @click="updateDirector">修改</el-button>
     <el-row :span="24">
  <el-col :span="6">
     总数:{{count}}<br/>
     值:{{form}}<br/>
    <!-- <avue-input v-model="form" placeholder="请输入内容" ></avue-input> -->
  </el-col>
</el-row>
    </div>
</template>

<script>
import bankapis  from "../../api/bank";
export default {
    data() {
      return {
        form:'我是内容',
        count:0,
         param: {
               keyword: ""
            },
      }
    },
    created() {
        this.getDirectorList();
    },
    methods: {
      getDirectorList(){
          let param={
            keyword:"",
            pageSize:10,
            pageIndex:1
          }
          bankapis.getDirectorList(param).then(res => {
                            this.$data.form=res.list;
                            this.$data.count=res.count
                    });
    
      },
      getDirectorById(){
          let param={
            Id: "1"
          };
         bankapis.getDirectorById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addDirector(){
          let param={
            BankSiteID:"1",
            UserID:"127",
            Type:"1",
            Tel:"123"
          };
         bankapis.addDirector(param).then(res => {
                        if(res){
                         this.$message.success("新增成功");
                           this.getDirectorList();
                        }
                    });
      },
       deleteDirector(){
          let param={
            Id:2
          };
         bankapis.deleteDirector(param).then(res => {
                        if(res){
                         this.$message.success("删除成功");
                           this.getDirectorList();
                        }
                    });
      },
       updateDirector(){
          let param={
            Tel:'sssse',
            Id:'2'
          };
         bankapis.updateDirector(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getDirectorList();
                        }
                    });
      },
      
    }
};
</script>

<style scoped>
h1 {
    text-align: center;
    margin: 30px 0;
}
p {
    line-height: 30px;
    margin-bottom: 10px;
    text-indent: 2em;
}
.logout {
    color: #409eff;
}
</style>